import { schema } from 'normalizr'

const educationalLevelSchema = new schema.Entity('educationalLevels')

const gradeSchema = new schema.Entity('grades', {
  education_level: educationalLevelSchema,
})

const studentsSchema = new schema.Entity('students', {
  grade: gradeSchema,
})

export const studentsOfSchoolSchema = [studentsSchema]

const schoolsSchema = new schema.Entity('schools', { idAttribute: 'id' })
const schoolsArray = [schoolsSchema]

export default schoolsArray



// WEBPACK FOOTER //
// ./src/schemas/schools.js